var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import merge from "lodash/merge";
import { getUpdateAction } from "./update.actions";
export var getUpdateDefaultState = function () { return ({
    data: {},
    update: {},
}); };
export var registerUpdateActions = function (params) {
    var entityName = params.entityName, reducer = params.reducer;
    var routine = getUpdateAction({ entityName: entityName });
    // Start
    reducer.on(routine.types.START, function (state, _a) {
        var _b;
        var id = _a.id;
        return merge({}, state, {
            // TODO:
            // @ts-ignore
            update: (_b = {},
                _b[id] = {
                    isUpdating: true,
                    updateError: undefined,
                },
                _b),
        });
    });
    // Success
    reducer.on(routine.types.SUCCESS, function (state, _a) {
        var _b, _c;
        var data = _a.data;
        return (__assign(__assign({}, state), { data: __assign(__assign({}, state.data), (_b = {}, _b[data.id] = data, _b)), update: __assign(__assign({}, state.update), (_c = {}, _c[data.id] = {
                isUpdating: false,
                updateError: undefined,
            }, _c)) }));
    });
    // Failure
    reducer.on(routine.types.FAILURE, function (state, _a) {
        var _b;
        var id = _a.id, error = _a.error;
        return merge({}, state, {
            // TODO:
            // @ts-ignore
            update: (_b = {},
                _b[id] = {
                    isUpdating: false,
                    updateError: error,
                },
                _b),
        });
    });
};
